<template>
  <div class="form-item">
    <el-form
      label-position="right"
      :label-width="'95px'"
      :model="params"
      :rules="rules"
      ref="queryFrom"
      :disabled="isEdit"
    >
      <el-row>
        <template v-for="(baseColumn, i) in baseColumns">
          <el-row :key="i" :gutter="10">
            <template v-for="(column, index) in baseColumn">
              <template v-if="!column.isHide">
                <el-col v-if="column.type == 'input-area'" :key="column.name" :span="24">
                  <el-form-item :label="column.name" :prop="column.prop">
                    <!--输入框-->
                    <el-input
                      style="width: 100%"
                      :maxlength="column.maxlength || 256"
                      v-model="params[column.prop]"
                      :placeholder="column.placeholder || $t('search.input')"
                      clearable
                      :readonly="column.readonly || false"
                      :disabled="column.disabled || false"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col v-else :key="index" :span="column.span || 6">
                  <!--开始时间-->
                  <template v-if="column.type == 'startDaterangePicker'">
                    <el-form-item
                      :label="column.name"
                      :prop="column.prop"
                      :class="{ propClass: column.name.trim().length > propLength }"
                    >
                      <el-date-picker
                        clearable
                        style="width: 100%"
                        v-model="params[column.prop]"
                        type="date"
                        :placeholder="column.placeholder || $t('search.choose')"
                        value-format="yyyy-MM-dd"
                        :disabled="column.disabled"
                        :picker-options="pickerStartOptions"
                        @focus="() => handleFocusDate('start', column.prop, column.index)"
                      ></el-date-picker>
                    </el-form-item>
                  </template>
                  <!--结束时间-->
                  <template v-else-if="column.type == 'endDaterangePicker'">
                    <el-form-item
                      :label="column.name"
                      :prop="column.prop"
                      :class="{ propClass: column.name.trim().length > propLength }"
                    >
                      <el-date-picker
                        clearable
                        style="width: 100%"
                        v-model="params[column.prop]"
                        type="date"
                        :placeholder="column.placeholder || $t('search.choose')"
                        value-format="yyyy-MM-dd"
                        :disabled="column.disabled"
                        :picker-options="pickerEndOptions"
                        @focus="() => handleFocusDate('end', column.prop, column.index)"
                      ></el-date-picker>
                    </el-form-item>
                  </template>
                  <!--checkbox-->
                  <template v-else-if="column.type == 'checkbox'">
                    <el-form-item label-width="90px" :prop="column.prop">
                      <el-checkbox
                        v-model="params[column.prop]"
                        :true-label="column.trueLable"
                        :false-label="column.falseLable"
                        :disabled="column.disabled || false"
                        @change="(val) => handleChange(val, column.prop, column.changeMethod)"
                        >{{ column.name }}</el-checkbox
                      >
                      <el-button
                        style="margin-left: 20px; height: 30px"
                        type="primary"
                        v-if="column.moreBtn || false"
                        @click="changeMethod(column.key, '', column.changeMethod)"
                        >{{ $t('salePurchase.search.credit') }}</el-button
                      >
                    </el-form-item>
                  </template>
                  <el-form-item
                    v-else
                    :label="column.name"
                    :class="{ propClass: column.name.trim().length > propLength }"
                    :prop="column.prop"
                  >
                    <!--输入框-->
                    <el-input
                      style="width: 100%"
                      v-if="column.type == 'input'"
                      :maxlength="column.maxlength || 32"
                      v-model="params[column.prop]"
                      :placeholder="column.placeholder || $t('search.input')"
                      clearable
                      :readonly="column.readonly || false"
                      :disabled="column.disabled || false"
                      @input="(val) => handleChange(val, column.prop, column.changeMethod)"
                    ></el-input>
                    <!--数字输入-->
                    <el-input
                      style="width: 100%"
                      v-if="column.type == 'inputNumber'"
                      v-model="params[column.prop]"
                      :placeholder="column.placeholder || $t('search.input')"
                      :disabled="column.disabled || false"
                      :maxlength="column.maxlength || 32"
                      @input="
                        (val) =>
                          limitAmount(
                            val,
                            column.max,
                            column.prop,
                            column.changeMethod,
                            column.precision
                          )
                      "
                    >
                      <template v-if="column.append" slot="append">{{ column.append }}</template>
                    </el-input>
                    <!--单选框-->
                    <el-select
                      style="width: 100%"
                      v-if="column.type == 'select'"
                      v-model="params[column.prop]"
                      :placeholder="column.placeholder || $t('search.choose')"
                      @change="
                        (val) => {
                          changeMethod(val, column.relatedColumn, column.changeMethod, column.prop);
                        }
                      "
                      @clear="
                        (val) => {
                          clearMethod(val, column.clearMethod);
                        }
                      "
                      filterable
                      :clearable="column.clearabled || true"
                      :disabled="column.disabled || false"
                    >
                      <el-option
                        v-for="item in column.options"
                        :key="item[column.value || 'value']"
                        :label="item[column.label || 'label']"
                        :value="item[column.value || 'value']"
                      ></el-option>
                    </el-select>
                    <!--获取后端数据渲染的下拉框-->
                    <ajax-select
                      style="width: 100%"
                      v-if="column.type == 'ajaxSelect'"
                      v-model="params[column.prop]"
                      :placeholder="column.placeholder || $t('search.choose')"
                      :apiUrl="column.apiUrl"
                      :apiData="column.apiData"
                      :multiple="column.multiple || false"
                      :clearable="column.clearable || true"
                      :filterable="column.filterable || true"
                      :dataString="column.dataString"
                      :valueKey="column.valueKey"
                      :labelKey="column.labelKey"
                      :method="column.method"
                      :moreShowKey="column.moreShowKey"
                      :valueType="column.valueType || 'string'"
                      :disabled="column.disabled"
                      @input="(val) => handleChange(val, column.prop, column.changeMethod)"
                    ></ajax-select>
                    <!--日期-->
                    <el-date-picker
                      style="width: 100%"
                      v-if="column.type == 'date'"
                      v-model="params[column.prop]"
                      type="date"
                      :placeholder="column.placeholder || $t('search.choose')"
                      value-format="yyyy-MM-dd"
                      :clearable="column.clearable || false"
                      :disabled="column.disabled"
                      :picker-options="pickerOptions"
                      @focus="() => handleSendDate(column.prop)"
                      @change="(val) => handleChange(val, column.prop, column.changeMethod)"
                    ></el-date-picker>
                    <!--tree-->
                    <tree-select
                      style="width: 100%"
                      ref="treeSelect"
                      v-if="column.type == 'treeSelect'"
                      :model="column.prop"
                      :apiUrl="column.apiUrl"
                      :apiData="column.apiData"
                      :clearable="column.clearable"
                      :currentValue="column.currentValue || null"
                      :returnType="column.returnType || ''"
                      :isMultiple="column.isMultiple || false"
                      :disabled="column.disabled"
                      @setSearchModal="setSearchModal"
                    ></tree-select>
                    <!-- 下拉表格 -->
                    <search-table
                      ref="searchTable"
                      v-if="column.type == 'searchTableSpec'"
                      v-model="params[column.prop]"
                      :searchType="column.searchType"
                      :checkRowKeys="column.checkRowKeys"
                      :currentValue="column.currentValue"
                      :isMultiple="column.isMultiple"
                      :extraData="column.extraData"
                      :disabled="column.disabled"
                      @input="(val) => handleChange(val, column.prop, column.changeMethod)"
                    ></search-table>
                    <!--inputLocal-->
                    <el-row :gutter="0">
                      <el-col :span="12" style="padding-right: 5px">
                        <el-input
                          v-if="column.type == 'inputLocal'"
                          v-model="params[column.prop]"
                          :placeholder="column.placeholder || $t('search.input')"
                          :disabled="column.disabled || false"
                          :maxlength="column.maxlength || 32"
                          @input="
                            (val) =>
                              limitAmount(
                                val,
                                column.max,
                                column.prop,
                                column.changeMethod,
                                column.precision
                              )
                          "
                          @blur="
                            (val) => blurAmount(val, column.max, column.prop, column.changeMethod)
                          "
                        ></el-input>
                      </el-col>
                      <el-col :span="12" style="padding-left: 5px">
                        <el-input
                          v-if="column.moreInput"
                          v-model="params[column.moreProp]"
                          :disabled="column.moreDisabled"
                          :placeholder="column.morePlaceholder || $t('search.input')"
                          :maxlength="column.maxlength || 32"
                        ></el-input>
                      </el-col>
                    </el-row>
                  </el-form-item>
                </el-col>
              </template>
            </template>
          </el-row>
        </template>
      </el-row>
    </el-form>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import { toFormErrorTop } from '@/common/js/util';
  // import SearchModal from '@/components/SearchModal';
  import ajaxSelect from '@/components/form-item/ajax-select';
  import treeSelect from '@/components/form-item/tree-select';
  import searchTable from '@/components/form-item/search-table';

  export default {
    name: 'formItem',
    components: {
      // SearchModal,
      ajaxSelect,
      treeSelect,
      searchTable, // 弹窗搜索：包括 商品、人员等，可新增
    },
    data() {
      return {
        pickerStartOptions: {}, // 开始日期配置
        pickerEndOptions: {}, // 结束日期配置
        pickerOptions: {},
      };
    },
    props: {
      params: {
        type: Object,
        default: () => {},
      },
      /**
       * columns筛选参数：
       * name:'名称'
       * prop:'字段名字'
       * type'编辑类型',['inpput','select','selectMultiple','date','datetime']
       * options:当编辑类型是select时的初始数据。
       * maxlength:可输入的最大长度
       */
      columns: {
        type: Array,
        default: () => [],
      },
      /**
       * 校验规则
       */
      rules: {
        type: Object,
        default: () => {},
      },
      /**
       * 日期
       */
      date: {
        type: String,
        default: () => '',
      },
      /**
       * 是否可编辑
       */
      isEdit: {
        type: Boolean,
        default: () => false,
      },
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      baseColumns() {
        let areaList = [];
        let result = [];
        let list = [];
        // for (let i = 0; i < this.columns.length; i++) {
        //   this.columns[i].index = i;
        //   if (this.columns[i].type != 'input-area') {
        //     if (!this.columns[i].isHide) list.push(this.columns[i]);
        //   } else {
        //     areaList.push([this.columns[i]]);
        //   }
        // }
        for (let i = 0; i < list.length; i += 4) {
          result.push(list.slice(i, i + 4));
        }
        return result.concat(areaList);
      },
      propLength() {
        return this.$store.getters.language == 'zh_CN' ? 6 : 14;
      },
    },
    methods: {
      // 清除校验
      clearValidate() {
        this.$refs.queryFrom.clearValidate();
      },
      handleFocusDate(type, prop, index) {
        const dateProp =
          type == 'start' ? this.columns[index + 1].prop : this.columns[index - 1].prop;
        const pickerOptions = {
          disabledDate: (time) => {
            return this.disabledDate(time, dateProp, type);
          },
        };
        if (type == 'start') {
          this.pickerStartOptions = pickerOptions;
        } else {
          this.pickerEndOptions = pickerOptions;
        }
      },
      handleSendDate(prop) {
        if (prop == 'lastestShipmentDate' || prop == 'lastestDeliveryDate') {
          if (this.date == '') {
            this.pickerOptions = {};
          } else {
            const pickerOptions = {
              disabledDate: (time) => {
                return time.getTime() < new Date(this.date).getTime() - 24 * 60 * 60 * 1000;
              },
            };
            this.pickerOptions = pickerOptions;
          }
        } else if (prop == 'lastestReceiveMoneyDay' || prop == 'lastestSendProductDay') {
          const pickerOptions = {
            disabledDate: (time) => {
              return time.getTime() < new Date().getTime() - 24 * 60 * 60 * 1000;
            },
          };
          this.pickerOptions = pickerOptions;
        } else {
          this.pickerOptions = {};
        }
      },
      // 开始结束日期禁用日期
      disabledDate(time, prop, type) {
        if (type === 'end') {
          let startDate = this.params[prop];
          if (startDate) {
            return time.getTime() < new Date(startDate).getTime() - 24 * 60 * 60 * 1000;
          }
        } else {
          let endDate = this.params[prop];
          if (endDate) {
            return time.getTime() > new Date(endDate).getTime();
          }
        }
      },
      //设置表单值
      setSearchModal(model, row) {
        if (model == 'decreaseOverflowDepartment') {
          if (row) {
            //如果是业务部门
            this.params[model] = row.id;
            this.params.decreaseOverflowDepartmentName = row.label;
            this.params.decreaseOverflowDepartmentNo = row.id;
          }
        } else {
          this.params[model] = row;
        }
        this.$emit('changeCurrency', { val: row, prop: model });
      },
      //number限制长度和位数
      limitAmount(value, max, prop, method, precision) {
        value = value.toString().replace(/[^\d.]/g, ''); //清除"数字"和"."以外的字符
        value = value.toString().replace(/^\./g, ''); //验证第一个字符是数字
        value = value.toString().replace(/\.{2,}/g, '.'); //只保留第一个, 清除多余的
        value = value.toString().replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
        if (precision == 1) {
          value = value.toString().replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3'); //只能输入一位小数
        } else if (precision == 2) {
          value = value.toString().replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两位小数
        } else if (precision == 3) {
          value = value.toString().replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3'); //只能输入四位小数
        } else if (precision == 4) {
          value = value.toString().replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3'); //只能输入四位小数
        } else if (precision == 5) {
          value = value.toString().replace(/^(\-)*(\d+)\.(\d\d\d\d\d).*$/, '$1$2.$3'); //只能输入五位小数
        } else {
          value = value.toString().replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3'); //只能输入六位小数
        }
        if (Number(value) >= Number(max)) {
          value = max;
        }
        if (prop == 'overShippedPercentage') {
          this.params['shortShippedPercentage'] = value;
        }
        this.params[prop] = value;
        if (!method) {
          return;
        }
        //运输信息不调用父页面方法
        if (
          prop == 'freightExpense' ||
          prop == 'freightExpense' ||
          prop == 'outInExpense' ||
          prop == 'loadingUnitPrice' ||
          prop == 'deliveryUnitPrice' ||
          prop == 'acceptanceDiscountUnitPrice'
        ) {
          return;
        }
        this.$emit(method, { prop: prop, val: value });
      },
      blurAmount(value, max, prop, method) {
        this.$emit(method, { prop: prop, val: this.params[prop] });
      },
      //选中塞值
      handleChange(val, prop, method) {
        //如果定价，则清空定价规则的必填校验
        if (prop == 'isFixedPrice') {
          this.params['pricingRule'] = null;
          this.$refs.queryFrom.clearValidate('pricingRule');
        }
        //如果是不是预付,则清空预付金额
        //如果是不是赊销,则清空赊销金额
        if (prop == 'isPrepay' || prop == 'isCreditsale') {
          this.params['creditAmount'] = null;
          this.params['creditPercent'] = null;
        }
        if (!method) {
          return;
        }
        this.$emit(method, { val: val, prop: prop });
      },
      //select修改事件
      changeMethod(val, relatedColumn, method, prop) {
        if (!method) {
          return;
        }
        if (relatedColumn) {
          this.params[relatedColumn] = null;
        }
        if (prop) {
          this.$emit(method, { val: val, prop: prop });
        } else {
          this.$emit(method, { val: val });
        }
      },
      clearMethod(val, method) {
        if (!method) {
          return;
        }
        this.$emit(method, { val: val });
      },
      //基本信息的值 进行重新赋值
      // 获取表单的值
      getValues() {
        const data = this.params;
        const result = Object.assign({}, data, {
          adminFlag: this.userInfo.userInfo.adminFlag,
          tenantCode: this.userInfo.userInfo.tenantCode,
          companyCode: this.userInfo.userInfo.companyCode,
          companyName: this.userInfo.userInfo.companyName,
          departmentCode: this.userInfo.userInfo.departmentCode,
          departmentName: this.userInfo.userInfo.departmentName,
          // customerNo: data.customer ? data.customer[0].partnerCode : null, // 客户编码
          // customerName: data.customer ? data.customer[0].partnerZhName : null, // 客户名称
          // supplierNo: data.supplier ? data.supplier[0].partnerCode : null, // 供应商编码
          // supplierName: data.supplier ? data.supplier[0].partnerZhName : null // 供应商名称
        });
        return result;
      },
      //校验
      submit(type) {
        return new Promise((resolve) => {
          if (type == '0') {
            resolve();
          } else {
            this.$refs['queryFrom'].validate((valid) => {
              if (valid) {
                resolve();
              } else {
                // 验证错误跳转至第一个错误提示得地方
                toFormErrorTop();
                return false;
              }
            });
          }
        });
      },
    },
  };
</script>
<style lang="sass" scoped></style>
